export default {
    nav: {
        profile: "Perfil",
        information: "Información"
    },
    profile: {
        title: "Cambiar avatar",
        buttons: {
            logout: "Exit",
            change_password: "Cambiar contraseña",
            events: "eventos"
        }
    },
    information: {
        count: ({count}) => `Número de mensajes : ${count}`
    }
}